import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './callkit.js';
// import App from './upload';
// import VConsole from 'vconsole';
import reportWebVitals from './reportWebVitals';

// const vConsole = new VConsole();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
